export class ProjetoCompletoConstant {

  public static IMPORTAR_IRCP = [
    {
      id: 1,
      name: "Importar Projetos IRCP",
      label: "Importação Projetos IRCP",
      titleModal: "Importação Dados para Consulta Popular",
      file: "importacao_exemplo.csv",
    },
    {
      id: 2,
      name: "Importar Entregas IRCP",
      label: "Importação Entregas IRCP",
      titleModal: "Importação Entregas dos projetos vinculados a Consulta Popular",
      file: "importacao_issue_ircp_exemplo.csv",
    },
    {
      id: 3,
      name: "Importar Projetos IRFE",
      label: "Importar Projetos IRFE",
      titleModal: "Importação Projetos IRFE",
      file: "import_type_3.csv",
    },
    {
      id: 4,
      name: "Importar Indicadores Tabela Simples",
      label: "Importar Indicadores Tabela Simples",
      titleModal: "Importação Indicadores Tabela Simples",
      file: "import_type_4.csv",
    },
    {
      id: 5,
      name: "Importar Indicadores Tabela Numerador/Denominador",
      label: "Importar Indicadores Tabela Numerador/Denominador",
      titleModal: "Importação Indicadores Tabela Numerador/Denominador",
      file: "import_type_5.csv",
    },
    {
      id: 6,
      name: "Importar Status Operacional IRCP",
      label: "Importar Status Operacional IRCP",
      titleModal: "Importar Status Operacional IRCP",
      file: "import_type_6.csv",
    },
  ];
}
